import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Cabserviceinkalyancabservice() {



const cardData = {
  keyword: " Cab Service in Kalyan / Cab Service in Dombivali",

headingDescription:
  "Omshree Cab provides professional and reliable Cab Service in Kalyan / Cab Service in Dombivali, ensuring travelers experience seamless, safe, and comfortable transfers to any destination in Mumbai or nearby cities. Whether you are arriving for business, leisure, or a family trip, our airport taxi service offers punctual pickups, well-maintained vehicles, and experienced chauffeurs who are familiar with airport procedures, traffic patterns, and city routes. We provide flexible booking options including one-way rides, round trips, and outstation trips with transparent pricing. Our fleet includes air-conditioned sedans, SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and corporate clients. With 24/7 customer support and convenient online booking, Omshree Cab is your trusted partner for hassle-free airport transportation from Mumbai International Airport.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "Gateway of India, located in South Mumbai, is one of the city’s most iconic landmarks and a popular tourist destination. Travelers can enjoy sightseeing, photography, and ferry rides to Elephanta Island. A taxi from Mumbai International Airport provides a comfortable and quick transfer to this historic monument while avoiding the hassle of city traffic and parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal promenade along the Arabian Sea, famous as the Queen’s Necklace for its nighttime lights. Visitors enjoy sunset views, evening walks, and the relaxing sea breeze. Airport taxi services make it convenient to reach Marine Drive directly from Mumbai International Airport and explore nearby attractions in comfort."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beaches, known for its lively atmosphere, street food, and beautiful sunsets. Visitors come to enjoy walking along the shore and tasting local delicacies. A taxi service from the airport ensures a smooth and comfortable ride directly to the beach without worrying about public transport or navigating traffic."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a famous Hindu temple in Mumbai dedicated to Lord Ganesha. Devotees and tourists visit for blessings, rituals, and spiritual experience. Using a taxi from Mumbai International Airport allows travelers to reach the temple comfortably and efficiently while avoiding parking issues and heavy traffic."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "Bandra Worli Sea Link is a modern engineering marvel connecting Bandra and Worli across the Arabian Sea. The bridge offers spectacular views of the sea and skyline, especially during sunset. A taxi from the airport provides a convenient and scenic ride across this landmark while ensuring a smooth journey to other parts of the city."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a renowned Islamic shrine located on an islet in the Arabian Sea. Visitors come for prayers and to enjoy the serene views. Airport taxi services provide hassle-free access to this spiritual site, ensuring a comfortable and timely ride for tourists and devotees alike."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut caves on Elephanta Island, a UNESCO World Heritage Site known for intricate sculptures dedicated to Lord Shiva. Visitors take a ferry from Gateway of India to reach the island. A taxi from Mumbai International Airport ensures smooth transport to the Gateway, making the trip convenient and stress-free."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large green forest reserve in Mumbai offering trekking, wildlife, nature walks, and the historic Kanheri Caves. Visitors enjoy an escape from the city’s hustle and bustle. A taxi from the airport provides an efficient and comfortable way to reach the park and explore its natural and historical attractions."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling street in South Mumbai known for shopping, street stalls, cafes, and cultural experiences. Visitors come for fashion, handicrafts, and local cuisine. Taxi service from the airport allows visitors to reach this vibrant market conveniently and continue their sightseeing comfortably."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, or Pherozeshah Mehta Gardens, are terraced gardens on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors enjoy peaceful walks, photography, and scenic relaxation. A taxi from Mumbai International Airport ensures travelers reach this scenic spot comfortably, integrating it into a full city sightseeing itinerary."
  }
],



services: [
{
name: "Cab Service in Kalyan",
description: "Cab service in Kalyan provides comfortable and reliable transportation for passengers traveling within the city and nearby destinations. Our fleet includes well-maintained AC sedans and SUVs suitable for local rides, airport transfers, and outstation trips. Professional drivers ensure punctual pickup and safe driving across Kalyan and surrounding areas. Pickup services are available from homes, offices, hotels, railway stations, and commercial hubs. Ideal for daily commuting, business travel, and family trips. Spacious seating and air-conditioned interiors ensure comfortable journeys. Flexible booking options allow easy cab reservations anytime."
},
{
name: "Taxi Service in Kalyan",
description: "Taxi service in Kalyan offers convenient and dependable transportation for passengers traveling across the city and nearby regions. Our air-conditioned taxis provide smooth travel through busy city roads and highways. Professional drivers ensure punctual pickup and courteous service for every ride. Pickup services are available from residential areas, offices, hotels, and railway stations in Kalyan. Ideal for airport transfers, local travel, and outstation trips. Comfortable seating ensures relaxed journeys for passengers. Easy booking options allow passengers to reserve taxis quickly and conveniently."
},
{
name: "Kalyan Cab Service",
description: "Kalyan cab service provides reliable city transportation for passengers looking for comfortable travel options. Our fleet includes AC sedans and SUVs suitable for short trips and long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Kalyan and nearby locations. Pickup services are available from homes, offices, hotels, and transport hubs. Ideal for corporate travel, family outings, and daily commuting. Spacious interiors provide comfortable seating for passengers. Flexible ride booking options allow easy scheduling anytime."
},
{
name: "Kalyan Taxi Service",
description: "Kalyan taxi service offers smooth and comfortable travel for passengers moving across Kalyan and nearby cities. Our well-maintained AC taxis ensure safe and convenient rides for all types of travelers. Professional drivers provide punctual pickup and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and marketplaces in Kalyan. Ideal for airport transfers, tourism visits, and business travel. Comfortable interiors ensure relaxed journeys during travel. Quick booking options allow passengers to reserve taxis easily."
},
{
name: "Cab Booking Kalyan",
description: "Cab booking in Kalyan allows passengers to quickly reserve comfortable vehicles for local or outstation travel. Our booking system offers instant ride confirmation and convenient scheduling options. Professional drivers ensure punctual pickup and safe driving for every trip. Pickup services are available across Kalyan including homes, offices, hotels, and railway stations. Ideal for daily commuting, airport transfers, and family travel. Spacious seating ensures comfortable journeys for passengers. Flexible booking options allow easy cab reservations anytime."
},
{
name: "Taxi Booking Kalyan",
description: "Taxi booking in Kalyan provides convenient transportation options for passengers looking to reserve taxis quickly. Our AC vehicles ensure smooth and comfortable travel across city roads and nearby highways. Professional drivers ensure punctual pickup and safe driving services across Kalyan. Pickup services are available from homes, offices, hotels, railway stations, and shopping areas. Ideal for business travel, tourism visits, and personal trips. Comfortable seating ensures relaxed journeys for passengers. Flexible booking options allow instant taxi reservations anytime."
},
{
name: "Cab Service in Dombivli",
description: "Cab service in Dombivli provides dependable transportation for passengers traveling within the city and nearby destinations. Our fleet includes comfortable AC sedans and SUVs suitable for local travel and outstation trips. Professional drivers ensure punctual pickup and safe driving services across Dombivli and surrounding areas. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for daily commuting, airport transfers, and business travel. Spacious interiors ensure comfortable seating for passengers. Flexible booking options allow convenient cab reservations anytime."
},
{
name: "Taxi Service in Dombivli",
description: "Taxi service in Dombivli offers reliable transportation for passengers seeking comfortable and convenient city travel. Our air-conditioned taxis ensure smooth journeys across Dombivli and nearby regions. Professional drivers provide punctual pickup and safe driving services for every ride. Pickup services are available from residential areas, offices, hotels, and transport hubs in Dombivli. Ideal for business travel, airport transfers, and local trips. Comfortable seating ensures relaxed journeys during travel. Easy booking options allow passengers to reserve taxis quickly."
},
{
name: "Dombivli Cab Service",
description: "Dombivli cab service provides efficient and comfortable transportation for passengers traveling across the city and nearby destinations. Our fleet includes AC sedans and SUVs suitable for local travel and long-distance journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations in Dombivli. Ideal for corporate travel, family trips, and tourism visits. Spacious seating ensures comfortable journeys for passengers. Flexible ride booking options allow easy cab reservations."
},
{
name: "Dombivli Taxi Service",
description: "Dombivli taxi service offers convenient city transportation with reliable vehicles and professional drivers. Our AC taxis provide smooth travel across Dombivli and nearby areas. Drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from residential areas, offices, hotels, and commercial locations. Ideal for daily commuting, airport transfers, and business trips. Comfortable interiors ensure relaxed journeys for passengers. Flexible booking options allow quick taxi reservations anytime."
},
{
name: "Cheap Cab Service Kalyan",
description: "Cheap cab service in Kalyan offers affordable transportation for passengers looking for budget-friendly travel options. Our economical AC sedans provide comfortable rides for local and short-distance travel. Professional drivers ensure punctual pickup and safe driving services across Kalyan. Pickup services are available from homes, offices, hotels, railway stations, and marketplaces. Ideal for students, daily commuters, and budget travelers. Comfortable interiors ensure relaxed journeys during travel. Flexible booking options allow convenient ride scheduling anytime."
},
{
name: "Best Taxi Service Dombivli",
description: "Best taxi service in Dombivli provides premium transportation experience with well-maintained vehicles and professional drivers. Our fleet includes comfortable AC sedans and SUVs suitable for city travel and long-distance journeys. Drivers ensure punctual pickup and safe driving services for every ride. Pickup services are available across Dombivli including homes, offices, hotels, and railway stations. Ideal for corporate travel, airport transfers, and tourism visits. Spacious interiors ensure comfortable journeys for passengers. Flexible booking options allow quick and easy taxi reservations."
}
],

tableData: [
["Cab Service in Kalyan","Taxi Service in Kalyan"],
["Kalyan Cab Service","Kalyan Taxi Service"],
["Cab Booking Kalyan","Taxi Booking Kalyan"],
["Cab Service in Dombivli","Taxi Service in Dombivli"],
["Dombivli Cab Service","Dombivli Taxi Service"],
["Cheap Cab Service Kalyan","Best Taxi Service Dombivli"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Airport Pickup & Drop",
    WhyChoosedescription: "Omshree Cabs provides dependable taxi services at Mumbai International Airport with punctual pickup and drop facilities. Our drivers track flight timings to ensure passengers are picked up on time even if flights are delayed."
  },
  {
    WhyChooseheading: "Transparent Airport Taxi Pricing",
    WhyChoosedescription: "We provide clear and transparent pricing for Mumbai International Airport taxi services. Customers are informed about the total fare, toll charges, and travel packages before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Airport Taxi Availability",
    WhyChoosedescription: "Our taxi service at Mumbai International Airport operates 24 hours a day. Whether your flight arrives early morning or late at night, Omshree Cabs ensures convenient transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized, providing passengers with a comfortable and relaxing airport travel experience."
  },
  {
    WhyChooseheading: "Airport Transfers to Multiple Destinations",
    WhyChoosedescription: "Passengers can book airport taxis from Mumbai International Airport to destinations like Pune, Thane, Navi Mumbai, Lonavala, Nashik, and other nearby cities."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Meet & Greet Service at Airport",
    WhyChoosedescription: "Our drivers provide convenient meet-and-greet service at the airport arrival area. They assist passengers with luggage and ensure a smooth transition from the airport to the cab."
  },
  {
    WhyChooseheading: "Trusted Airport Taxi Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for airport taxi services in Mumbai. Our punctual service, professional drivers, and comfortable vehicles ensure a stress-free airport journey."
  }
]
};

const faqData = [
  { question: "Do you provide taxi service at Mumbai International Airport?", answer: "Yes, Omshree Cabs provides reliable taxi services at Mumbai International Airport for pickup and drop." },
  { question: "Is airport taxi service available 24 hours?", answer: "Yes, our taxi service operates 24/7 for arrivals and departures at Mumbai International Airport." },
  { question: "Do you provide airport taxis to Pune or other cities?", answer: "Yes, we provide outstation airport taxi services from Mumbai Airport to Pune, Nashik, Lonavala, and many other cities." },
  { question: "Which terminals do you serve at Mumbai Airport?", answer: "We provide taxi services for both Terminal 1 and Terminal 2 of Mumbai International Airport." },
  { question: "Which vehicles are available for airport transfers?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on passenger requirements." },
  { question: "Do drivers track flight arrivals?", answer: "Yes, our drivers monitor flight timings to ensure timely pickup even if flights are delayed." },
  { question: "Are airport taxis air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during peak travel hours and holiday seasons." },
  { question: "Can I book airport taxi online?", answer: "Yes, customers can book airport taxis online or via phone for quick confirmation." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vikram Desai",
    feedback:
      "We booked Omshree Cabs for pickup at Mumbai International Airport. The driver was waiting on time and helped with luggage. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Shah",
    feedback:
      "Very reliable airport taxi service in Mumbai. Smooth ride, clean car, and professional driver made our travel comfortable.",
    rating: 5
  }
];




















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Kalyan / Cab Service in Dombivali",
  "description": "Omshree Cab provides reliable cab service in Kalyan and Dombivali for local travel, airport transfers, and outstation trips. Affordable fares, easy online booking, and trusted taxi service ensure a comfortable and safe ride across Kalyan, Dombivali, and nearby areas.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2200"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Cab Service in Kalyan / Cab Service in Dombivali | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers reliable cab service in Kalyan and Dombivali for local travel, airport transfers, and outstation trips. Affordable fares and easy online booking for trusted taxi service in Kalyan and Dombivali." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinkalyancabservice;